// Per-link upload session for /r/[token]. Stores just enough to resume an
// in-flight inbound upload: orderID + file fingerprints + the token it was
// minted for. tus-js-client owns the actual byte-level resume via its
// fingerprint URL storage — this is just the surrounding context (which
// orderID and which files the page was working with).

const PREFIX = "transfer:receive:"
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

const KEY = (token) => `${PREFIX}${token}`

function safeParse(raw) {
    try { return JSON.parse(raw) } catch { return null }
}

export function fingerprint(file) {
    return {
        name: file.name,
        size: file.size,
        type: file.type || "",
        lastModified: file.lastModified || 0,
    }
}

export function fileKey(fp) {
    return `${fp.name}:${fp.size}:${fp.lastModified}`
}

export function save(token, { orderID, entries, title, notes }) {
    if (typeof window === "undefined" || !token) return
    const data = {
        token,
        orderID,
        savedAt: Date.now(),
        title: title || "",
        notes: notes || "",
        files: (entries || []).map(({ file, path }) => ({ ...fingerprint(file), path })),
    }
    try { window.localStorage.setItem(KEY(token), JSON.stringify(data)) } catch {}
}

export function load(token) {
    if (typeof window === "undefined" || !token) return null
    const raw = window.localStorage.getItem(KEY(token))
    if (!raw) return null
    const data = safeParse(raw)
    if (!data || !data.orderID) { clear(token); return null }
    if (Date.now() - (data.savedAt || 0) > MAX_AGE_MS) { clear(token); return null }
    return data
}

export function clear(token) {
    if (typeof window === "undefined" || !token) return
    try { window.localStorage.removeItem(KEY(token)) } catch {}
}

export function matchPickedFiles(pickedEntries, savedFiles) {
    const wanted = new Map(savedFiles.map((f) => [fileKey(f), f]))
    const matched = []
    const extra = []
    for (const e of pickedEntries) {
        const k = fileKey(fingerprint(e.file))
        if (wanted.has(k)) {
            const saved = wanted.get(k)
            matched.push({ file: e.file, path: saved.path })
            wanted.delete(k)
        } else {
            extra.push(e)
        }
    }
    return { matched, missing: [...wanted.values()], extra }
}
